import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class Auth401Service {
  private bc = new BroadcastChannel('auth');

  constructor(
    private router: Router,
    private zone: NgZone,
    private authService: AuthService
  ) {
    console.log('[Capacitor] referenced in Auth401Service');
    // sincroniza abas (quando login/logout acontece em outra aba)
    window.addEventListener('storage', (e) => {
      if (e.key === 'access_token' || e.key === 'sanctum_marker') {
        // nada assíncrono aqui; o Guard e o Interceptor decidirão ao fazer a próxima navegação/request
      }
    });
    this.bc.onmessage = (ev) => {
      if (ev.data?.type === 'logout') this.localLogout(false);
      if (ev.data?.type === 'login') localStorage.setItem('sanctum_marker', '1');
    };
  }

  /** Chame isso ao finalizar login WEB (Sanctum) */
  markLoggedInWebSanctum() {
    localStorage.setItem('sanctum_marker', '1');
    this.bc.postMessage({ type: 'login' });
  }
  private forcing = false; 
  /** Logout local + navegação (opcional) */
  async forceLogout(fromInterceptor = false): Promise<void> {
    if (this.forcing) return;     // evita reentrância
    this.forcing = true;

    try {
      // Só chama o backend se foi um logout “manual”
      if (!fromInterceptor) {
        try { await this.authService.logout(); } catch { }
      }
    } finally {
      this.localCleanup();
      this.bc.postMessage({ type: 'logout' });
      this.safeNavigateLogin();
      // solta a trava um pouco depois para evitar múltiplos 401 simultâneos
      setTimeout(() => (this.forcing = false), 1500);
    }
  }

  private localCleanup(): void {
    // suas limpezas
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key?.startsWith('cachedInstagramAccounts_') || key?.startsWith('user_detail_')) {
        localStorage.removeItem(key);
      }
    }
    localStorage.removeItem('access_token');
    localStorage.removeItem('access_token_ebanking');
    localStorage.removeItem('domain_store');
    localStorage.removeItem('SelectedStoreId');
    localStorage.removeItem('user_name');
    localStorage.removeItem('user_id');
    localStorage.removeItem('use_trial');
    localStorage.removeItem('wallet_id');
    localStorage.removeItem('user_chat');
    localStorage.removeItem('user_ip');
    localStorage.removeItem('store');
    localStorage.removeItem('store_data');
    localStorage.removeItem('oauth');
    localStorage.removeItem('socket_jwt');
    localStorage.removeItem('sanctum_marker');
  }

  private safeNavigateLogin(): void {
    this.zone.run(() => {
      this.router.navigate(['/auth/login'], { replaceUrl: true }).then(() => {
        if (Capacitor.isNativePlatform()) window.location.reload();
      });
    });
  }

  private localLogout(navigate: boolean) {
    localStorage.removeItem('access_token');   // JWT (nativo)
    localStorage.removeItem('sanctum_marker'); // web
    localStorage.removeItem('user_id');
    if (navigate) this.router.navigate(['/auth/login'], { replaceUrl: true });
  }

  /** Utilitários para o Guard */
  isWebLoggedIn(): boolean {
    return localStorage.getItem('sanctum_marker') === '1';
  }
  isNativeLoggedIn(): boolean {
    const t = localStorage.getItem('access_token');
    if (!t) return false;
    try {
      const p = JSON.parse(atob(t.split('.')[1]));
      const now = Math.floor(Date.now() / 1000);
      return !(p?.exp && now >= p.exp);
    } catch { return false; }
  }
}

